import { DataLayer } from "@allwyn/utils/data-layer";

export namespace SmartBannerAnalytics {
    export const pushImpression = (appCode: string, platform: string): void => {
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [createPromo(appCode, platform)],
                },
            },
        });
    };

    export const pushClick = (appCode: string, platform: string): void => {
        DataLayer.pushInstant({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [createPromo(appCode, platform)],
                },
            },
        });
    };

    export const pushClose = (appCode: string, platform: string): void => {
        DataLayer.pushInstant({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [createPromo(appCode, platform, ".close")],
                },
            },
        });
    };
}

function createPromo(appCode: string, platform: string, suffix = "") {
    const name = `appInstalation.${appCode}.${platform}`;

    return {
        id: `${name}${suffix}`,
        name,
        creative: "simple",
        position: "top-popup",
    };
}
